export enum RegisterMethod {
  Funnel = 'funnel',
  Multiposting = 'multiposting',
  Transparent = 'transparent',
  FacebookForm = 'facebook_form',
  Docia = 'docia',
  QuickSignup = 'quick_signup',
}
